<script setup lang="ts">
defineProps<{
  isLoggedIn: boolean,
  loading: boolean,
}>();
</script>

<template>
  <div class="layout">
    <slot name="header" />
    <div class="flex size-full flex-auto">
      <slot name="sidebar" />
      <div class="layout-page-wrapper" :class="{ 'flex justify-center': !isLoggedIn }">
        <i-progress-bar
          v-if="loading"
          class="fixed! left-0 right-0 z-101"
        />
        <div class="layout-page">
          <slot name="content" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.layout-page, .layout-sidebar {
  height: calc(100vh - var(--p-layout-header-height));
}

.layout-page-wrapper {
  width: calc(100vw - var(--p-layout-sidebar-width));
  flex: 1 1 auto;
  position: relative;
}

.layout-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: var(--p-layout-page-padding);
  overflow: auto;
  position: relative;
  transition-property: max-width;
  transition-duration: .5s;
}
</style>
